var $ = require('jquery');

/**
 * Set an element dimensions to equal the window dimensions.
 * @param  {Element} el Element to resize.
 * @return {undefined}
 */
var fullSize = function (el) {
  var w = $(window).width();
  var h = $(window).height();

  $(el)
    .attr({
      width: w,
      height: h
    });
};

/**
 * Resize element on window resize.
 * @param  {Element} el Element to resize.
 * @return {undefined}
 */
var watch = function (el) {
  window.onresize = fullSize.call(null, el);
  fullSize(el);
};

module.exports = {
  fullSize: fullSize,
  watch: watch
};
